import PathPicker, { PathPickerType } from '../../../../PathPicker';
import {
	getValueByNodes,
	removeAssocItem,
	uploadPackageItems,
	uploadAttachment,
	onFormChange,
} from '../../../actions/form';
import { getValue } from '../../../lib/associations';
import { Dispatch } from 'redux';
import { FieldJson } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { is } from 'ramda';
import Upload from '../../../../Upload';
import { getAttachmentFormData } from '../../../lib/upload';
import { Icon } from '@mui/material';
import { uploadAttachment as uploadAttachmentWorkflow } from '../../../../../../document-details/actions/attachments';
import { createFormData } from '../../../../../../document-details/utils/attachmentData';
import prepareFormForSubmit from '../../../lib/prepareFormForSubmit';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	fetchWorkflowData,
	fetchTaskForm,
	fetchFiles,
	onFormSubmit,
} from '../../../../../../workflow-screen/actions/details';
import { toggleModal } from '../../../../ModalTest/actions';

const getType = (type: 'file' | 'folder' | 'all' | undefined): PathPickerType => {
	let result;
	switch (type) {
		case 'file': {
			result = PathPickerType.FILE;
			break;
		}
		case 'folder': {
			result = PathPickerType.FOLDER;
			break;
		}
		case 'all': {
			result = PathPickerType.ALL;
			break;
		}
		default: {
			result = PathPickerType.FILE;
		}
	}
	return result;
};

export interface AssociationInterface extends FieldJson, ReduxComponentInterface {
	mandatory: boolean;
	disabled: boolean;
	className: string;
	title: string;
	formInstanceId: string;
	isModalOpen: boolean;
	onChange?: (...args: any[]) => void;
	innerFormInstanceId?: string;
	upload?: boolean;
	selfId?: string;
	readOnly: boolean;
	repoPath: string;
	validate?: (name: string, value: any) => void;
	params?: any;
	task?: any;
	workflow?: any;
	form?: any;
	getPropBpmContext?: boolean;
}

class Association extends window.React.PureComponent<AssociationInterface> {
	async componentDidMount() {
		const { actions, value, init, name, formInstanceId, innerFormInstanceId, validate, mandatory } = this.props;
		const valueArray = getValue(value);
		const initArray = init ? getValue(init) : [];
		const res = await actions.getValueByNodes(formInstanceId, name, valueArray.concat(initArray), innerFormInstanceId);
		if (mandatory && validate) {
			validate(name, res.value.response.data.items);
		}
	}

	onItemDelete = (nodeRef: string) => {
		const { actions, formInstanceId, innerFormInstanceId, name } = this.props;
		actions.removeAssocItem(formInstanceId, name, nodeRef, innerFormInstanceId);
	};
	onItemDeleteWF = async (nodeRef: string) => {
		const { actions, form, task, workflow } = this.props;
		const file = this.props.workflow.documents.filter((item: any) => item.nodeRef === nodeRef)[0];
		actions.toggleModal(true, 'deleteDocsModal', {
			title: window.Alfresco.messages.global['edocat.deleteDoc.title'],
			message: window.Alfresco.util.message('edocat.deleteDoc.text', null, file.name),
			deleteFunction: async () => {
				const data = prepareFormForSubmit(form.fields, null, false, false, [], true);
				data['eassoc_packageItems'] = data['eassoc_packageItems'].filter((item: any) => item !== nodeRef);
				await actions.onFormSubmit(data, form.submissionUrl);

				await actions.fetchWorkflowData(workflow.processId);

				if (this.props.workflow.documents?.length > 0) {
					actions.fetchFiles(this.props.workflow.documents.map(item => item.nodeRef));
				}

				actions.fetchTaskForm(task.id, 'edit', data);
			},
		});
	};

	onSubmit = async (nodeRefs: string[]) => {
		const { actions, formInstanceId, innerFormInstanceId, name, validate, mandatory } = this.props;
		const res = await actions.getValueByNodes(formInstanceId, name, nodeRefs, innerFormInstanceId);
		if (mandatory && validate) {
			validate(name, res.value.response.data.items);
		}
	};

	changeOrder = async (result: any) => {
		const { actions, value, formInstanceId, name, innerFormInstanceId, validate } = this.props;
		const { source, destination } = result;
		let newValues;
		if (source && destination && source.index !== destination.index) {
			const draggedRule = value[source.index];

			if (destination.index > source.index) {
				const [i, j] = [source.index, destination.index];

				newValues = [
					...value.slice(0, i),
					...value.slice(i + 1, j + 1).map((item, index) => ({ ...item, position: value[i + index].position })),
					{ ...draggedRule, position: value[j].position },
					...value.slice(j + 1),
				];
			} else {
				const [i, j] = [destination.index, source.index];

				newValues = [
					...value.slice(0, i),
					{ ...draggedRule, position: value[i].position },
					...value.slice(i, j).map((item, index) => ({ ...item, position: value[i + index + 1].position })),
					...value.slice(j + 1),
				];
			}
		}
		newValues && actions.onFormChange(formInstanceId, [name], newValues, innerFormInstanceId, true);
	};

	onTaskUpload = async (file: any, onProgress: Function) => {
		const { actions, control: { params } } = this.props;
		const formData = createFormData(file, params.bpm_context);
		const response = await actions.uploadAttachmentWorkflow(formData, onProgress, params.bpm_context);
		return response;
	};

	callback = async (nodeRefs: string[], attachments: boolean = false) => {
		const { actions, form, task, workflow } = this.props;

		const data = prepareFormForSubmit(form.fields, null, false, false, [], true);
		data['eassoc_packageItems'] = [
			...new Set(
				(attachments ? data['eassoc_packageItems'] : []).concat(
					nodeRefs
				)
			)
		];

		await actions.onFormSubmit(data, form.submissionUrl);

		await actions.fetchWorkflowData(workflow.processId);

		if (this.props.workflow.documents?.length > 0) {
			actions.fetchFiles(this.props.workflow.documents.map(item => item.nodeRef));
		}

		actions.fetchTaskForm(task.id, 'edit', data);
	};

	onUpload = async (file: any, onProgress: Function) => {
		const {
			actions,
			formInstanceId,
			innerFormInstanceId,
			control: {
				params,
			},
			name,
		} = this.props;

		if (params._taskId) {
			/*			const formData = createFormData(file, bpm_context);
						await actions.uploadAttachmentWorkflow(formData, onProgress, bpm_context);
						/*await actions.uploadPackageItems(
							formInstanceId,
							getWorkflowFormData(params._taskId, file),
							name,
							innerFormInstanceId,
							onProgress
						);*/
		} else if (params.parentNodeRef) {
			await actions.uploadAttachment(
				formInstanceId,
				getAttachmentFormData(params.parentNodeRef, file),
				name,
				innerFormInstanceId,
				file.name,
				onProgress,
			);
		} else {
			throw new Error('No upload action provided');
		}
	};

	render() {
		const {
			name,
			label,
			mandatory,
			disabled,
			value,
			error,
			formInstanceId,
			selfId,
			control: {
				params,
			},
			readOnly,
			repeating,
			getPropBpmContext
		} = this.props;

		const enableUpload = (params?._taskId && params?.pckg_mode && params?.pckg_upload) || params.enableUpload;
		const type = getType(params?.type);

		return readOnly ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<div id={name}>
					{value?.length > 0 ? (
						Array.isArray(value) ? (
							value.map((it, index) => {
								return (
									<div key={index} className="edcMetaLink" id={it.nodeRef}>
										<a href={`${window.appContext}/page/document-details?nodeRef=${it.nodeRef}`} target="_blank">
											<Icon className="Icon fa fa-file-alt" fontSize="small" />
											{it.name}
										</a>
									</div>
								);
							})
						) : (
							<div dangerouslySetInnerHTML={{ __html: value }} />
						)
					) : (
						<div>{window.Alfresco.messages.global['label.none']}</div>
					)}
				</div>
			</div>
		) : (
			<div
				id={name}
				className={`assoc-row ${enableUpload ? 'form-row package-items' : 'form-row'} row-${name}${
					readOnly ? ' simple-row' : ''
				}`}
			>
				<label>
					{label}
					{mandatory ? '*' : ''}
				</label>
				<span className="error-title">{error}</span>
				<PathPicker
					isMandatory={mandatory}
					disabled={readOnly || disabled}
					type={type}
					showFileList
					pckg_mode={params?.pckg_mode !== undefined ? params.pckg_mode : undefined}
					bpm_context={params?.bpm_context ?? ''}
					pckg_upload={params?.pckg_upload !== undefined ? params.pckg_mode === 'EDIT' && params.pckg_upload : undefined} // this has to be there on true for visible button for upload
					multiSelect={repeating ?? true}
					formInstanceId={formInstanceId}
					reducerPath={[formInstanceId, 'formModal']}
					selected={
						value ? (is(String, value) ? value.split(',') : value.map((item: any) => item.nodeRef || item)) : []
					}
					hidden={params?.bpm_context ? [params.bpm_context] : selfId ? [selfId] : []}
					onItemDelete={params?._taskId ? this.onItemDeleteWF : this.onItemDelete}
					params={params}
					changeOrder={getPropBpmContext ? this.changeOrder : undefined}
					onSubmit={params?._taskId ? this.callback : this.onSubmit}
					name="assocModal"
					id={name}
					uploadButton={
						enableUpload && !disabled && !readOnly ?
							<Upload
								multiple={repeating ?? true}
								showButton
								name="packageItemsUpload"
								uploadAction={params._taskId ? this.onTaskUpload : this.onUpload}
								callback={this.callback}
								disallowedExtensions={params.disallowedExtensions || []}
							/>
							:
							''
					}
				/>
				{/*enableUpload && !disabled && !readOnly && (
					<Upload
						multiple={repeating ?? true}
						showButton
						name="packageItemsUpload"
						uploadAction={params._taskId ? this.onTaskUpload : this.onUpload}
						callback={this.callback}
						disallowedExtensions={params.disallowedExtensions || []}
					/>
				)*/}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators(
		{
			getValueByNodes,
			removeAssocItem,
			uploadPackageItems,
			uploadAttachment,
			uploadAttachmentWorkflow,
			fetchWorkflowData,
			fetchTaskForm,
			fetchFiles,
			onFormSubmit,
			toggleModal,
			onFormChange,
		},
		dispatch,
	),
});

const mapStateToProps = (state: any) => ({
	params: state?.navigation?.params,
	task: state?.details?.task,
	workflow: state?.details?.workflow,
	form: state?.taskForm?.form,
});

export default connect(mapStateToProps, mapDispatchToProps)(Association);
